import { t } from "./helpers/localization";
import get from "lodash/get";

/*
This permissions are equal to clans.roles permissions.
*/
export const permissions = {
  RENAME_CLAN: 'edit_info',
  CHANGE_SETTINGS: 'change_settings',
  CHANGE_ROLE: 'change_role',
  CHANGE_COMMANDER: 'change_commander',
  HANDLE_INVITES: 'handle_invites',
  INVITE: 'invite',
  REMOVE_MEMBER: 'remove_member',
  REMOVE_CLAN: 'remove_clan',
  SUPPLY_VIEW_CLAN_ADMITTANCE: 'supply_view_clan_admittance',
  SUPPLY_APPLY_MODIFIER: 'supply_apply_modifier',
  CWARS_TOGGLE_PARTICIPATION: 'cwars_toggle_participation'
};

const roles = [{
  name: 'commander',
  rank: 10,
  localized_name: t('Командующий флотом'),
  order: 0,
  permissions: [permissions.RENAME_CLAN, permissions.CHANGE_SETTINGS, permissions.CHANGE_ROLE, permissions.CHANGE_COMMANDER, permissions.HANDLE_INVITES, permissions.INVITE, permissions.REMOVE_MEMBER, permissions.REMOVE_CLAN, permissions.SUPPLY_VIEW_CLAN_ADMITTANCE, permissions.SUPPLY_APPLY_MODIFIER, permissions.CWARS_TOGGLE_PARTICIPATION]
}, {
  name: 'executive_officer',
  rank: 9,
  localized_name: t('Заместитель командующего'),
  order: 1,
  permissions: [permissions.RENAME_CLAN, permissions.CHANGE_SETTINGS, permissions.CHANGE_ROLE, permissions.HANDLE_INVITES, permissions.INVITE, permissions.REMOVE_MEMBER, permissions.SUPPLY_VIEW_CLAN_ADMITTANCE, permissions.SUPPLY_APPLY_MODIFIER, permissions.CWARS_TOGGLE_PARTICIPATION]
}, {
  name: 'recruitment_officer',
  rank: 5,
  localized_name: t('Военком'),
  order: 5,
  permissions: [permissions.HANDLE_INVITES, permissions.INVITE]
}, {
  name: 'commissioned_officer',
  rank: 0,
  localized_name: t('Кадровый офицер'),
  order: 8,
  permissions: []
}, {
  name: 'officer',
  rank: 0,
  localized_name: t('Офицер'),
  order: 9,
  permissions: []
}, {
  name: 'private',
  rank: 0,
  localized_name: t('Курсант'),
  order: 10,
  permissions: []
}];

export const roleNames = roles.map(role => role.name);

export const getLocalizedName = roleName => {
  const role = roles.find(role => role.name === roleName);
  return role ? role.localized_name : '';
};

export const iHavePermission = (permission, currentAccount) => {

  if (currentAccount) {
    return hasPermission(currentAccount.roleName, permission);
  } else {
    return false;
  }
};

export const hasPermission = (roleName, permission) => {
  return getPermissions(roleName).includes(permission);
};

export const hasAnyPermission = (roleName, permissions) => {
  const rolePermissions = getPermissions(roleName);
  return permissions.some(permission => rolePermissions.includes(permission));
};

const getPermissions = roleName => {
  const role = roles.find(role => role.name === roleName);
  return role ? role.permissions : [];
};

export const getRank = roleName => {
  const role = roles.find(role => role.name === roleName);
  return role ? role.rank : -1;
};

export const getOrder = roleName => {
  const role = roles.find(role => role.name === roleName);
  return role ? role.order : 100;
};

export const getAssignableRoles = roleName => {
  const currentRoleRank = getRank(roleName);
  return roles.filter(role => role.rank < currentRoleRank).map(role => role.name);
};

export const getFirstAssignableRole = roleName => {
  const currentRoleRank = getRank(roleName);
  return roles.find(role => role.rank < currentRoleRank).name;
};